import { render, staticRenderFns } from "./peopleList.vue?vue&type=template&id=07f632f3&scoped=true&"
import script from "./peopleList.vue?vue&type=script&lang=js&"
export * from "./peopleList.vue?vue&type=script&lang=js&"
import style0 from "./peopleList.vue?vue&type=style&index=0&id=07f632f3&scoped=true&lang=css&"
import style1 from "./peopleList.vue?vue&type=style&index=1&id=07f632f3&lang=scss&scoped=true&"
import style2 from "./peopleList.vue?vue&type=style&index=2&id=07f632f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f632f3",
  null
  
)

export default component.exports